import React from 'react';
import { Typography, Button } from '@one-thd/sui-atomic-components';

export interface EmptyStateAction {
  label: string;
  href: string;
}

export interface EmptyStateProps {
  headline: string;
  description?: React.ReactNode;
  primaryAction?: EmptyStateAction;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ headline, description, primaryAction }) => (
  <div className="sui-flex sui-flex-col sui-items-center sui-gap-3">
    <Typography weight="bold">{headline}</Typography>
    {description && <Typography>{description}</Typography>}
    {primaryAction && (
      <Button href={primaryAction.href} variant="primary">
        {primaryAction.label}
      </Button>
    )}
  </div>
);
